import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "~/utils/tailwind";

const buttonVariants = cva(
  ["inline-flex justify-center items-center rounded-md cursor-pointer"],
  {
    variants: {
      variant: {
        primary: [
          "bg-gradient-to-br from-orange-400 to-primary hover:from-primary hover:to-primary active:from-orange-600 active:to-orange-600 text-white disabled:from-neutral-200 disabled:to-neutral-200 disabled:text-neutral-400 disabled:cursor-not-allowed",
        ],
        secondary: [
          "ring-1 ring-inset ring-red-500 text-red-500 hover:bg-orange-100 active:bg-orange-200 disabled:ring-neutral-200 disabled:bg-transparent disabled:text-neutral-400 disabled:cursor-not-allowed",
        ],
        tertiary: [
          " text-orange-500 hover:bg-orange-100 active:bg-orange-200 disabled:ring-neutral-200 disabled:bg-transparent disabled:text-neutral-400 disabled:cursor-not-allowed",
        ],
        transparent: ["bg-transparent"],
      },
      size: {
        large: ["px-4 py-3"],
        medium: ["px-3 py-2"],
        small: ["px-2 py-1"],
      },
      font: {
        base: "",
        bold: "text-base",
        bolder: "",
      },
      radius: {
        small: "rounded-sm",
        medium: "rounded-md",
        large: "rounded-lg",
        full: "rounded-full",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "large",
      font: "bold",
      radius: "large",
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const SubmitButton: React.FC<ButtonProps> = ({
  variant,
  size,
  className,
  font,
  radius,
  children,
  disabled = false,
  ...props
}) => {
  return (
    <button
      disabled={disabled}
      className={cn(buttonVariants({ variant, size, font, radius, className }))}
      {...props}
    >
      {children}
    </button>
  );
};
